import React, {Component} from 'react';
import {connect} from 'react-redux';
import '../resources/stylesheets/login.css';
import '../resources/stylesheets/register.css';
import AppUserRegister from "../components/AppUserRegister";
import {postAppUser} from "../actions/registerAppUser";
import {loginVerifierUser} from "../login/api.actions";
import history from '../history';
import * as type from '../constants/ActionTypes';

class RegisterContainer extends Component {

  constructor(props) {
    super(props);
    this.postRegistration = this.postRegistration.bind(this);
    this.state = {}
  }


  postRegistration(formDetails) {

    const {dispatch} = this.props;

    dispatch(postAppUser(formDetails)).then((response) => {

      if (response && response.type === type.APP_USER_POST_SUCCESS) {
        dispatch(loginVerifierUser(formDetails)).then(response => {
          if (response && response.isAuthenticated) {
            localStorage.setItem('username', formDetails.username);

            const clientUrlName = new URLSearchParams(window.location.search).get("client");

            if(clientUrlName)
              localStorage.setItem('clientRegistration', clientUrlName);

            history.push('/home/clients');
          }
        }).catch(function (e) {
          console.log(e.message);
        });
      } else {
        console.log('response', response);
        this.setState({ error : response.error.message });
      }
    });
  }


  render() {
    const {error} = this.state;

    return (
      <AppUserRegister onSubmit={this.postRegistration} error={error}/>
    );
  }
}

export default connect()(RegisterContainer);
